export default "__VITE_ASSET__64R4pnTLGDYLbDkEnxWSjg__"